// removed by extract-text-webpack-plugin
module.exports = {"Content":"Layout__Content__3pLYC"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Layout/Layout.css
// module id = 155
// module chunks = 3